export const theme1: object = {
    palette: {
        primary: {
            light: '#81b4c1',
            main: '#219EBC',
            dark: '#023047',
            dark2: '#001723',
            contrastText: '#fff',
        },
        secondary: {
            main: '#D32626',
        },
        success: {
            main: '#79D70F',
        },
        warning: {
            main: '#F5A31A',
        },
        grey: {
            '100': '#f5f5f5',
            '500': '#CCCCCC',
            '700': '#808080',
        },
    },
    menu: {
        selected: {
            text: '#FFB703',
            background: '#FFFFFF',
        },
        nested: {
            background: '#001723',
        },
    },
    overrides: {
        MuiCard: {
            // Name of the rule
            root: {
                backgroundColor: '#f5f5f5',
            },
        },
    },
};
